<div style="display: block;">
    <canvas mdbChart
        [chartType]="chartType"
        [datasets]="chartDatasets"
        [colors]="chartColors"
        [labels]="chartLabels"
        [legend]=true
        [options]="chartOptions">
    </canvas>
</div>